import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks } from "@/services/misc/functions/ValidationFunctions";

export class CreateSystemUserForm {
  public name: string = '';
  public server: string = '';
  public password: string = '';
  public passwordConf: string = '';
  public directory: string;
  public quota: number = 200000;
  public expireDate: Date;
  public quotaMultiplier: number = 1;
  public websiteId: number;
}
